/**
 * Table artifact template for dashboard module
 *
 * Delegates to TableArtifact with dashboard variant for single rendering path.
 * Currency comes from dashboard context (useResourceCurrency) via rendererProps.
 * DataGrid state persistence is passed when rendering in dashboard module.
 * Registers for dashboard download when rendered in a panel.
 */
import TableArtifact from "connected-components/ai-teammate/components/table-artifact"
import { useMemo } from "react"
import { useRegisterDownloadData } from "hooks/use-register-download-data"
import { usePanelTitle } from "connected-components/dashboard/context/panel-id"
import { artifactToDownloadData } from "connected-components/ai-teammate/helpers/artifact-to-download-data"
import type { ArtifactTemplateProps } from "connected-components/dashboard/modules/ai-artifact/types"

export default function TableTemplate({
  artifact,
  currency,
  dataGridState,
  onDataGridStateChange,
}: ArtifactTemplateProps) {
  const panelTitle = usePanelTitle()
  const downloadRegistration = useMemo(() => ({
    key: `ai-artifact-table-${artifact.id}`,
    sheetName: panelTitle ?? "AI Table",
    getData: () => artifactToDownloadData(artifact, currency),
  }), [artifact, currency, panelTitle])
  useRegisterDownloadData(downloadRegistration)

  if (artifact.type !== "table") {
    return null
  }

  return (
    <TableArtifact
      artifact={artifact}
      variant="dashboard"
      currency={currency}
      dataGridState={dataGridState}
      onDataGridStateChange={onDataGridStateChange}
    />
  )
}
